import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto/900.css";
import { ThemeProvider } from "@emotion/react";
import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { theme } from "./app/theme";
import { router } from "./app/router";
import { store } from "./app/store";
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { Fragment, ReactNode, useEffect } from "react";
import { AuthDialogProvider } from "./context/auth-dialog-context";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import {visitorSlice} from "./app/slices/visitorSlice"
import Footer from "./components/Footer";
import { useVisitorData } from "@fingerprintjs/fingerprintjs-pro-react";
const queryClient = new QueryClient()

const InitialLoader = ({ children }: { children: ReactNode }) => {
  const dispatch = useAppDispatch();
  const { requestId } = useAppSelector((state) => state.visitor);

  const {
    data: fjsData,
    isLoading: isVisitorLoading,
    getData: getVisitorData,
  } = useVisitorData({ extendedResult: false }, { immediate: true });

  useEffect(() => {
    const fpjsCheck = async () => {
      if (!fjsData?.requestId && !isVisitorLoading) {
        //if request id is still undefined then the user is using
        //some kind of ad blocker to prevent fingerprint js to take
        //metrics of the user's browser. We should display some kind
        //of alert to let the user know
        await getVisitorData();
      } else if(requestId == undefined) {
        dispatch(visitorSlice.actions.setReqeustId({requestId: fjsData?.requestId}))
      }
    };
    fpjsCheck();
  }, [fjsData, isVisitorLoading]);

  return <Fragment>{children}</Fragment>
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <AuthDialogProvider>
            <InitialLoader>
              <RouterProvider router={router} />
            </InitialLoader>
          </AuthDialogProvider>
        </QueryClientProvider>
        <Footer />
      </Provider>
    </ThemeProvider>
  );
}

export default App;
